export default __webpack_public_path__ + "static/race-day-virtual-vertical-4b686052607b5bcdef630aa16bbde557.png";